import React from "react";
import TabPane from "../../../components/Tab/TabPane";
import CommonInput from "../../../components/forms/CommonInput";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import {
  handleChange,
  handleChangeNameValue,
  handleChangeNumeral,
} from "../../../helpers/handleFormChanges";
import TabHelper from "../../../helpers/TabHelper";
import PropTypes from "prop-types";
import CommonTextArea from "../../../components/forms/CommonTextArea";

function ServicoTab({ tabAtualHook, checkServicoTab, valuesHook, salvaServico }) {
  const { values, setValues } = valuesHook;
  const { tabAtual, setTabAtual } = tabAtualHook;

  const [valorTotal, setValorTotal] = React.useState("");

  React.useEffect(() => {
    const valorUnitarioNum = parseFloat(values.valorUnitario);
    const quantidadeNum = parseFloat(values.quantidade);

    if (!isNaN(valorUnitarioNum) && !isNaN(quantidadeNum)) {
      const total = valorUnitarioNum * quantidadeNum;
      setValorTotal(total.toFixed(2));
    } else {
      setValorTotal("");
    }
  }, [values.valorUnitario, values.quantidade]);

  const limparCampos = () => {
    setValues({
      ...values,
      descricaoServico: "",
      valorUnitario: "",
      quantidade: "",
    });
    setValorTotal("");
  };

  return (
    <TabPane>
      <div className="row">
        <div className="col-12 mb-3">
          <CommonTextArea
            label="Descrição do serviço"
            id="descricaoServico"
            value={values.descricaoServico}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            rows={5}
            required
          />
        </div>
        <div className="row" style={{ paddingRight: "0px" }}>
          <div className="col-lg-3 mb-3">
            <CommonInputValor
              label="Valor unitário"
              id="valorUnitario"
              value={values.valorUnitario}
              onChange={(e) => {
                handleChangeNameValue(
                  "valorUnitario",
                  e.target.value,
                  values,
                  setValues
                );
              }}
              required
            />
          </div>
          <div className="col-lg-3 mb-3">
            <CommonInput
              label="Quantidade"
              id="quantidade"
              value={values.quantidade}
              onChange={(e) => {
                handleChangeNumeral(
                  e,
                  values,
                  setValues
                );
              }}
              required
            />
          </div>
          <div className="col-lg-3 mb-3">
            <CommonInputValor
              label="Valor total"
              id="valorTotal"
              value={valorTotal}
              disabled
            />
          </div>
          <div
            className="col-lg-3 d-flex align-items-end justify-content-end mb-3"
            style={{ paddingRight: "0px" }}
          >
            <CommonButton
              onClick={() => {
                const resul = salvaServico();
                if(resul === true)
                  limparCampos();
              }}
              color="success"
              style={{ height: "44px" }}
            >
              Adicionar
            </CommonButton>
          </div>
        </div>
        <div className="row d-flex justify-content-between mx-1">
          <CommonButton
            onClick={() => {
              TabHelper.trocarTab(tabAtual, setTabAtual, -1);
            }}
            color="primary"
          >
            Anterior
          </CommonButton>
          <CommonButton
            onClick={() => {
              if(checkServicoTab())
                TabHelper.trocarTab(tabAtual, setTabAtual, 1);
            }}
            color="primary"
          >
            Próximo
          </CommonButton>
        </div>
      </div>
    </TabPane>
  );
}

ServicoTab.propTypes = {
  tabAtualHook: PropTypes.shape({
    tabAtual: PropTypes.number.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  checkServicoTab: PropTypes.func.isRequired,
  salvaServico: PropTypes.func.isRequired,
};

export default ServicoTab;
